module.exports = __webpack_public_path__ + "img/avatar.29b4c5c1.png";